const { SPACE } = require('../helpers');

exports.countryDefinition = {
  country: 'Gabon',
  code: 'GA',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'Town', width: 0.5 }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['stateCode', SPACE, 'city']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['city']],
  requiredFormFields: [{ field: 'address' }, { field: 'city' }]
};
